import { Duration } from 'luxon';

// Using language instead of date/time format as durations are shown in "human" readible, so should follow the language
export const parseDurationFromSeconds = (seconds: number, language: string): Duration => {
  if (seconds >= 86400) {
    const duration = Duration.fromMillis(seconds * 1000).shiftTo('days', 'hours', 'minutes');

    return Duration.fromObject(
      {
        days: duration.days,
        hours: duration.hours,
        minutes: Math.round(duration.minutes),
      },
      { locale: language },
    );
  } else if (seconds >= 3600) {
    const duration = Duration.fromMillis(seconds * 1000).shiftTo('hours', 'minutes', 'seconds');

    return Duration.fromObject(
      {
        hours: duration.hours,
        minutes: duration.minutes,
        seconds: Math.round(duration.seconds),
      },
      { locale: language },
    );
  } else if (seconds >= 60) {
    const duration = Duration.fromMillis(seconds * 1000).shiftTo('minutes', 'seconds');

    return Duration.fromObject(
      {
        minutes: duration.minutes,
        seconds: Math.round(duration.seconds),
      },
      { locale: language },
    );
  } else {
    const duration = Duration.fromMillis(seconds * 1000).shiftTo('seconds');

    return Duration.fromObject(
      {
        seconds: Math.round(duration.seconds),
      },
      { locale: language },
    );
  }
};
